<template>
  <div class="personal">
    <Nav @roomid="roomid"></Nav>
    <div style="height: 80px"></div>

    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
          <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div>我的位置：</div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item
                class="xinxi"
                :to="{ path: '/shezhiguanliyuan' }"
                ><span>主播管理</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item
                class="xinxi"
                :to="{ path: '/shezhiguanliyuan' }"
                ><span>设置管理员</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="title_box">
              <span class="lines"></span>
              <span>设置管理员</span>
            </div>
            <div class="set_admin">
              <div class="inputs">
                <span class="name">UID</span>
                <el-input
                  type="text"
                  placeholder="请输入UID"
                  v-model.trim="uid"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </div>
              <!-- <div style="margin-left:30px;">
                                <span style="color:#ffffff;">用户名称</span>
                                <input style="font-size:16px;color:#ffffff;padding-left:10px;width: 190px;height: 40px;background: #464646;border-radius: 4px 6px 6px 4px;margin-left:10px;border:0;outline: none;" placeholder="请输入用户名称" type="text">
                            </div> -->
              <div @click="Tianjiaguanli" class="add_uid">添加</div>
            </div>
            <div class="table_list">
              <div class="tb_header">
                <div style="width: 20%">UID</div>
                <div style="width: 60%">用户名</div>
                <div style="width: 30%">管理员设置</div>
              </div>
              <div class="tb_content">
                <div class="tb_content_item">
                  <div
                    v-for="(item, index) in roomList"
                    :key="index"
                    v-if="item.role !== 3"
                    class="tb_item"
                  >
                    <div style="width: 20%">{{ item.uid }}</div>
                    <div style="width: 60%">{{ item.nickname }}</div>
                    <div style="width: 30%; display: flex; align-items: center">
                      <img
                        @click="Quxiaoguanli(item.uid)"
                        style="cursor: pointer"
                        src="https://oss.ansongqiubo.com/assets/personimage/quxiaogl.png"
                        alt=""
                      />
                      <div
                        @click="Quxiaoguanli(item.uid)"
                        style="
                          cursor: pointer;
                          margin-left: 6px;
                          font-size: 14px;
                        "
                      >
                        取消管理
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import qs from "qs";
import slide from './template_slide.vue'

export default {
  name: "App",
  data() {
    return {
      b: 1,
      roomList: [],
      roomids: null, //用户id
      uid: null, //设置管理id
      activeName: 1,
    };
  },
  mounted() {
    this.roomid();
  },
  methods: {
    //   获取用户id
        changeSlide(data){
              this.$router.push(data);
            },
    roomid(e) {
      this.roomids = e;
      this.guanli(e);
    },
    //   获取管理员列表
    guanli(e) {
      console.log(this.roomids);
      this.$axios
        .get(this.api + "/v1/manage/room/list", {
          params: {
            roomId: e,
          },
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res);
          this.roomList = res.data.data;
        });
    },
    //   添加管理员
    Tianjiaguanli() {
      console.log(this.uid);
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            //   console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/manage/room/add",
        method: "post",
        data: {
          roomId: this.roomids,
          uid: this.uid,
        },
      }).then((res) => {
        //   console.log(res);
        if (res.data.message == "success") {
          this.guanli(this.roomids);
          this.uid = "";
        } else {
          alert("操作出现问题");
        }
      });
    },
    //   取消管理员
    Quxiaoguanli(e) {
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            //   console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/manage/room/remove",
        method: "post",
        data: {
          roomId: this.roomids,
          uid: e,
        },
      }).then((res) => {
        //   console.log(res);
        if (res.data.message == "success") {
          this.guanli(this.roomids);
        } else {
          alert("操作出现问题");
        }
      });
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    dianji(e) {
      this.b = e;
    },
    Mingcheng(e, i) {
      // console.log(e,i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      // if (e==1&&i==0) {
      //     this.$router.push('/shezhiguanliyuan')
      // }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
  },
  components: {
    Nav,
    slide
  },
};
</script>

<style scoped lang='scss'>
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-right .el-collapse-item__header {
  // background: #000 !important;
}
.el-collapse-item__wrap {
  background-color: #f7f8fa !important;
}

.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.title_box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .lines {
    display: inline-block;
    width: 4px;
    margin-right: 6px;
    border-radius: 4px;
    height: 20px;
    background: #721edc;
  }
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  max-width: 998px;
  flex: 2;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}
.personal-bottom-bottom-right-bottom {
  height: calc(94% - 15px);
  box-sizing: border-box;
  margin-top: 25px;
  padding-top: 25px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.table_list {
  box-sizing: border-box;
  color: #ffffff;
  margin-top: 25px;
}
.tb_content {
  .tb_content_item {
    height: 330px;
    overflow-y: auto;
  }
}
.tb_item {
  line-height: 47px;
  padding-left: 10px;
  display: flex;
  color: rgba(102, 102, 102, 1);
  height: 47px;
  padding: 0 12px;
  background-color: rgba(247, 248, 250, 1);
  border-bottom: 1px solid rgba(102, 102, 102, .1);
}
.tb_header {
  // min-width: 958px;
  padding: 0 12px;
  height: 34px;
  background: #faf6ff;
  line-height: 34px;
  display: flex;
  height: 34px;
  font-weight: 400;
  color: #333333;
  font-size: 16px;
}
.add_uid {
  cursor: pointer;
  margin-left: 30px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;

  width: 64px;
  height: 36px;
  line-height: 36px;
  background: #721edc;
  border-radius: 4px 6px 6px 4px;
  background: #721edc;
  border-radius: 4px;
}
.set_admin {
  display: flex;
  align-items: center;
  margin-top: 15px;
  .inputs {
    display: flex;
    align-items: center;

    span.name {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-right: 12px;
    }
  }
}
.daohang {
  display: flex;
  width: 500px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.xzcxzcxz {
  color: white;
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
</style>
<style>
.inputs .el-input__inner {
  width: 190px;
  height: 36px;
  background: #f7f8fa;
  border-radius: 4px;
}
.inputs .el-input .el-input__count .el-input__count-inner {
  background: #f7f8fa;
}
</style>
<style>
.el-input__inner:focus {
  border: 1px solid #d6d8df;
}

.xzcxzcxz {
  color: white;
}
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}
.personal-bottom-bottom-left .is-active {
  color: #721edc;
}
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/component/Shezhiguanliyuan.vue